import { useModalStore } from "@/stores/use-modal-store";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { Indicator } from "@/components/ui/indicator";
import { useEffect } from "react";

/*
 * ReactionInfoModal component
 *
 * This modal displays information about the Reaction metric and its four categories:
 * Positive, Negative, Neutral, and Mixed.
 */
export const ReactionInfoModal = () => {
  /* Hooks */
  const { close, setConfig } = useModalStore((state) => state.modalActions);

  /* Side Effects */
  useEffect(() => {
    setConfig({ className: "w-full max-w-[460px]" });
  }, [setConfig]);

  /* Render */
  return (
    <div className="flex flex-col gap-4">
      {/* Header */}
      <div className="flex items-center justify-center relative">
        <h2>Reaction</h2>
        <XMarkIcon onClick={close} className="size-5 cursor-pointer absolute right-0" />
      </div>

      {/* Description */}
      <p className="text-center">The overall positive or negative reaction towards an asset:</p>

      {/* Reaction Categories */}
      <div className="flex flex-col">
        {/* Positive */}
        <div className="grid grid-cols-[95px_1fr] items-center gap-3 px-4 py-5 border-b border-base-300">
          <div className="flex items-center gap-2 py-1.5">
            <Indicator color="#80B918" size="small" />

            <p className="font-semibold text-sm">Positive</p>
          </div>
          <p className="text-xs font-medium text-base-content/70 max-w-[245px]">Overall positive (pleasant) reaction towards an asset.</p>
        </div>

        {/* Negative */}
        <div className="grid grid-cols-[95px_1fr] items-center gap-3 px-4 py-5 border-b border-base-300">
          <div className="flex items-center gap-2 py-1.5">
            <Indicator color="#DC3545" size="small" />

            <p className="font-semibold text-sm">Negative</p>
          </div>
          <p className="text-xs font-medium text-base-content/70 max-w-[245px]">Overall negative (unpleasant) reaction towards an asset.</p>
        </div>

        {/* Neutral */}
        <div className="grid grid-cols-[95px_1fr] items-center gap-3 px-4 py-5 border-b border-base-300">
          <div className="flex items-center gap-2 py-1.5">
            <Indicator color="#8C8C90" size="small" />

            <p className="font-semibold text-sm">Neutral</p>
          </div>
          <p className="text-xs font-medium text-base-content/70 max-w-[245px]">No strong overall positive or negative reaction towards an asset.</p>
        </div>

        {/* Mixed */}
        <div className="grid grid-cols-[95px_1fr] items-center gap-3 px-4 py-5 border-b border-base-300">
          <div className="flex items-center gap-2 py-1.5">
            <Indicator color="#8C8C90" size="small" />

            <p className="font-semibold text-sm">Mixed</p>
          </div>
          <p className="text-xs font-medium text-base-content/70 max-w-[245px]">Mix of elements in the asset that predict both positive and negative reactions.</p>
        </div>
      </div>
    </div>
  );
};
